module.exports = __webpack_public_path__ + "img/facebook.2c5271df.svg";